/* eslint-disable @typescript-eslint/consistent-type-imports */
import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
})
export class SpinnerComponent {
  async ngOnInit(): Promise<void> {}
}
